module.exports = window.PlatformPhoenix_SkedUi